import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import {
  app,
  Types,
  getCourseEnrollments,
  getCourses,
  getStudentSubmissions,
  getStudentStates,
  updateStudentState,
  updateStudentSubmission,
  getContent,
  getUsers,
  loginWithEmail,
  getCredentials,
  signupWithEmail,
  getCourseWorks,
  googleAuth,
  addTrialLog,
  loginWithUidOrEmail
} from "@playpowerlabs/ppl-mathfluency-utils";
import _ = require("lodash");
import { IGetContentQuery } from "@playpowerlabs/ppl-mathfluency-utils/lib/getContent";
// import { IGetActivitiesResponse } from "@playpowerlabs/ppl-mathfluency-utils/getPrograms";

export interface ICredentials {
  // Customize received credentials here
  token: string;
  refreshToken: string;
  uid: string;
}

export interface ILoginContext {
  email: string;
  password: string;
  remember?: boolean;
}

const credentialsKey = "credentials";
export class AuthenticationService {
  // private _credentials: ICredentials;
  private apiKey = "AIzaSyA-cEZQHUo6xl28ibTSedw6iaBa9ysI274";
  private timer: any;
  private studentData;
  private studentStateId: string;
  public addTrialLog = addTrialLog;
  public getUsers = getUsers;
  public getCourseWorks = getCourseWorks;
  public updateStudentSubmission = updateStudentSubmission;
  constructor() {
    const config = {
      apiKey: this.apiKey,
      authDomain: "omega-rhino-227310.firebaseapp.com",
      projectId: "omega-rhino-227310"
    };
    const firebaseApp = firebase.initializeApp(config);

    // initialize pplFirebase
    app.initializeApp(firebaseApp, firebase);
    // googleAuth({ role: Types.UserPermissionRoles.STUDENT });
  }

  public async updatePatchSutdentSubmissionOnGoogleClassroom(data: any): Promise<any> {
    let url = "https://us-central1-omega-rhino-227310.cloudfunctions.net/patchStudentSubmissionOnGoogleClassroom";
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" }
    });
    return response;
  }

  public static async getContent(options: IGetContentQuery): Promise<any[]> {
    let libraries = await getContent(options);
    return libraries;
  }

  public async getEnrollments(options): Promise<any> {
    let courseEnrollments = await getCourseEnrollments(options);
    return courseEnrollments;
  }

  public async loginWithUid(uid): Promise<void> {
    try {
      return await loginWithUidOrEmail(uid);
    } catch (error) {
      throw console.error(error);
    }
  }

  public async getCourses(): Promise<any> {
    // await this.assignUserToAClass();
    let options = {
      studentId: getCredentials().uid
    };
    let dummyOptions = {
      studentId: "GSZFs88geBmXYbjcVcTQ"
    };
    let classesInfo = await getCourses(options);
    return classesInfo;
  }

  public async getStudentSubmissions(courseId: string): Promise<any> {
    let options = {
      studentId: getCredentials().uid,
      courseId: courseId
    };
    let dummyOptions = {
      studentId: "DxG2VhVxfp7xWIdCNfs4",
      courseId: "108hVvXV91nMTiAz6xUo"
    };
    let studentSubmission = await getStudentSubmissions(options);
    return studentSubmission;
  }
  public async getStudentState(): Promise<any> {
    let options = {
      studentId: getCredentials().uid
    };
    let studentState = await getStudentStates(options);
    this.studentStateId = studentState[0].id;
    return studentState[0].state;
  }
  public async updateStudentState(state): Promise<void> {
    if (!this.studentStateId) {
      console.warn(
        "trying to update student without geting...skipping update operation"
      );
      return;
    }
    await updateStudentState(this.studentStateId, { state });
  }

  public async googleClassSignInUp(): Promise<any> {
    return await googleAuth({ role: Types.UserPermissionRoles.STUDENT });
  }

  public async login(context: ILoginContext): Promise<any> {
    let { email, password } = context;
    let credentials = {
      email: email,
      password: password,
      role: Types.UserPermissionRoles.STUDENT
    };
    // credentials.email = "dev@playpowerlabs.com";
    // credentials.password = "tanmay123";
    try {
      return await loginWithEmail(credentials);
    } catch (error) {
      throw console.error(error);
    }
  }
}
